import { render } from "./BuddhaAI.vue?vue&type=template&id=acb95406&scoped=true"
import script from "./BuddhaAI.vue?vue&type=script&lang=js"
export * from "./BuddhaAI.vue?vue&type=script&lang=js"

import "./BuddhaAI.vue?vue&type=style&index=0&id=acb95406&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acb95406"]])

export default __exports__